import { TextNodeType } from "@tm/ui-widgets/components";
import styled from "styled-components";
import { ICommonPageData } from "../../pages/InsuranceCommonLanding/types";

export interface ProductInfoBanner {
  title?: TextNodeType;
  icon?: string;
  knowMore?: {
    title?: TextNodeType;
    url?: string;
  };
  pages?: {
    pageID: string;
    data: ICommonPageData;
  }[];
}

export interface ProductInfoSectionProps {
  productInfoBanner: ProductInfoBanner;
}

export interface KnowMoreProps {
  isMobile?: boolean;
}

export const BannerWrapper = styled.div`
  display: flex;
  border: 1px solid #fff;
  align-items: center;
  background: linear-gradient(90deg, #b3d6ff 0%, #eaf6ff 100%);
  border-radius: 16px;
  padding: 16px;
  gap: 16px;
  max-width: 600px;

  @media (max-width: 767px) {
    html:not([data-device="tablet"]) & {
      max-width: 100%;
      padding: 12px 16px;
    }
  }
`;

export const Icon = styled.img`
  width: auto;
  height: auto;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: #111;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  @media (max-width: 767px) {
    html:not([data-device="tablet"]) & {
      font-size: 14px;
    }
  }
`;

export const KnowMore = styled.a`
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  color: #008cff;
  margin-top: 2px;
`;

export const ArrowButton = styled.div`
  background-color: #3b82f6;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 8px;

  &:hover {
    background-color: #2563eb;
  }
`;

export const ArrowIcon = styled.svg`
  width: 20px;
  height: 20px;
`;

export const ArrowPath = styled.path`
  fill: #ffffff;
`;

export const KnowMoreTag = styled.span<KnowMoreProps>`
  font-weight: bold;
  font-size: ${(props) => (props.isMobile ? "12px" : "14px")};
  width: fit-content;
  cursor: pointer;
`;

export const MobileModalStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  flex-direction: column;
`;

export const DesktopModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
`;

export const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

export const DesktopModal = styled.div`
  position: relative;
  z-index: 2;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  aspect-ratio: 42/55;
  height: 75vh;
  width: auto;
  overflow: scroll;
`;
